import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';
import { filtersConfig } from '../utils';

const namespace = 'delegatedTasks';

const DelegatedTasksModel = {
  namespace,
  state: {
    ...initialState,
    filtersConfig,
  },
  effects: makeListEffects({
    namespace,
    fetchRoute: 'delegation/delegatedTasks',
    fetchParams: 'delegatedTasks',
  }),
  reducers: makeListReducers({
    initialPagination,
    initialState: {
      ...initialState,
      filtersConfig,
    },
  }),
};

export default DelegatedTasksModel;
